import { AuthenticationAPI } from './authentication.js';
import { COUNTRY_SWEDEN_ID, COUNTRY_UAE_ID, ROOT_URL } from './constants.js'
import fetcher from './fetcher.js';
import { searchParamsFromObject } from './utils.js';


class TransactionAPI {
  static async search({ query = '', offset = 0, limit = 50, instrument_name = '', person_id = '' }) {
    const params = searchParamsFromObject({ query, offset, limit, instrument_name, person_id }).toString();
    const transactionURL = `${ROOT_URL}/api/v1/market/transactions/search/`
    const url = `${transactionURL}?${params}`
    const res = await fetcher(url);
    const data = await res.json();
    return data;
  }
}

class InstrumentAPI {
  static getCurrencyName(country_id) {
    if (country_id === COUNTRY_SWEDEN_ID) {
      return 'SEK'
    } else if (country_id === COUNTRY_UAE_ID) {
      return 'AED'
    }
    return 'aed'
  }
  static async getHistoricalPriceListByISIN(isin) {
    const params = searchParamsFromObject({ isin }).toString();
    const url = `${ROOT_URL}/api/v1/market/historical-prices/isin/search/?${params}`
    const res = await fetcher(url);
    const data = await res.json();
    return data;
  }
  static async getHistoricalPriceListByTicker(ticker, limit=90) {
    const params = searchParamsFromObject({ ticker, limit }).toString();
    const url = `${ROOT_URL}/api/v1/market/historical-prices/isin/search/?${params}`
    const res = await fetcher(url);
    const data = await res.json();
    return data;
  }

  static async getList({
    country_id = COUNTRY_UAE_ID, offset = 0, limit = '', sort_by = '', query = '', market_slug = ''
  }) {
    const params = searchParamsFromObject({
      country_id,
      offset,
      limit,
      sort_by,
      query,
      market_slug
    }).toString();

    const url = `${ROOT_URL}/api/v1/market/instruments/search/?${params}`
    const res = await fetcher(url);
    const data = await res.json();
    return data;
  }

  static async getItem({instrument_id, country_id = COUNTRY_UAE_ID}) {
    const params = searchParamsFromObject({ instrument_id, country_id }).toString();
    const url = `${ROOT_URL}/api/v1/market/instruments/search/?${params}`
    const res = await fetcher(url);
    const data = await res.json();
    const item = data[0]
    return item;
  }

  static async getItemBySlug({instrument_slug, country_id = COUNTRY_UAE_ID}) {
    const params = searchParamsFromObject({ instrument_slug, country_id }).toString();
    const url = `${ROOT_URL}/api/v1/market/instruments/search/?${params}`
    const res = await fetcher(url);
    const data = await res.json();
    const item = data[0]
    return item;
  }

  static async generateStaticParams(country_id = COUNTRY_UAE_ID) {
    const instrumentList = await this.getList({ country_id, limit: 10 })
    const params = []
    instrumentList.forEach(element => {
      if(element.slug) {
        params.push({
          instrumentSlug: element.slug,
        })
      }
    })

    return params
  }
}

class SectorAPI {
  static sectors = {
    'global': [
      { name: 'All', value: 'null', backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/white-and-black-round-pendant-Ass0DusYDk4_s8eyqFy.jpg?tr=w-600,h-400,f-auto,pr-true,false',  },
      { name: 'Financials', value: 6, backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/city-buildings-during-night-time-41J9-JTIP-c_yKUQcU4.jpg?tr=w-600,h-400,f-auto,pr-true,false' },
      { name: 'Real Estate', value: 2, backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/aerial-photography-of-rural-r3WAWU5Fi5Q_NlCC8lU.jpg?tr=w-600,h-400,f-auto,pr-true,false' },
      { name: 'Utilities', value: 7, backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/blue-and-clear-body-of-water-K785Da4A_JA_bS0DLDE.jpg?tr=w-600,h-400,f-auto,pr-true,false' },
      { name: 'Materials', value: 8, backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/man-wearing-gloves-and-mask-holding-iron-qvCQCvPSCaw_DFvXx1w.jpg?tr=w-600,h-400,f-auto,pr-true,false' },
      { name: 'Communication Services', value: 9, backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/a-close-up-of-a-cell-phone-with-a-blue-background-1PpyUZceg_I_tZJ1ndr.jpg?tr=w-600,h-400,f-auto,pr-true,false' },
      { name: 'PrJSC', value: 1, backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/private-signage-door-u5Zt-HoocrM.jpg?tr=w-600,h-400,f-auto,pr-true,false' },
      { name: 'Industrials', value: 3, backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/vehicles-near-buildings-at-night-time-VmX3vmBecFE_LO3bcKh.jpg?tr=w-600,h-400,f-auto,pr-true,false' },
      { name: 'Consumer Discretionary', value: 4, backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/black-and-silver-analog-watch-1ZHw4bwCAys_JE3bf2I.jpg?tr=w-600,h-400,f-auto,pr-true,false' },
      { name: 'Consumer Staples', value: 5, backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/pile-of-vegetables-QvkAQTNj4zk_eLftiS1.jpg?tr=w-600,h-400,f-auto,pr-true,false' },
    ],
    'scandinavia': [
      { 
        name: 'Alla', 
        value: 'null', 
        backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/white-and-black-round-pendant-Ass0DusYDk4_s8eyqFy.jpg?tr=w-600,h-400,f-auto,pr-true,false', 
        alt: 'Medical Mask',
      },
      { 
        name: 'Finans', 
        value: 6, 
        backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/city-buildings-during-night-time-41J9-JTIP-c_yKUQcU4.jpg?tr=w-600,h-400,f-auto,pr-true,false', 
        alt: 'Financial building',
      },
      { 
        name: 'Industri', 
        value: 3, 
        backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/white-and-black-round-pendant-Ass0DusYDk4_s8eyqFy.jpg?tr=w-600,h-400,f-auto,pr-true,false',
        alt: 'Face mask',
      },
      { 
        name: 'Energi & Kraft', 
        value: 20, 
        backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/two-square-blue-led-lights-ImcUkZ72oUs_lJxufu0.jpg?tr=w-600,h-400,f-auto,pr-true,false',
        alt: 'Electricity flowing through air'
      },
      { 
        name: 'Medicinteknik', 
        value: 16, 
        backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/person-holding-silver-and-black-hand-tool-XknuBmnjbKg.jpg?tr=w-600,h-400,f-auto,pr-true,false', 
        alt: 'Medical Tools',
      },
      { 
        name: 'Finansiella tjänster', 
        value: 27, 
        backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/brown-and-white-concrete-building-7-gaPkhIgqs_6U08Sir.jpg?tr=w-600,h-400,f-auto,pr-true,false',
        alt: 'Bank offices from above',
      },
      { 
        name: 'Konsumentprodukter', 
        value: 17, 
        backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/person-using-laptop-FlPc9_VocJ4_Dk25OnE.jpg?tr=w-600,h-400,f-auto,pr-true,false',
        alt: 'People pointing to a laptop',
      },
      { 
        name: 'Konsumenttjänster', 
        value: 11, 
        backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/human-hand-holding-plasma-ball-vEE00Hx5d0Q_IixVEVP.jpg?tr=w-600,h-400,f-auto,pr-true,false',
        alt: 'Human hand holding a plasma ball',
      },
      { 
        name: 'Media', 
        value: 14, 
        backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/black-laptop-computer-turned-on-with-red-light-ooCoR8x0MmY.jpg?tr=w-600,h-400,f-auto,pr-true,false',
        alt: 'Youtube play button',
      },
      { 
        name: 'Fastighet', 
        value: 2,
        backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/aerial-photography-of-rural-r3WAWU5Fi5Q_NlCC8lU.jpg?tr=w-600,h-400,f-auto,pr-true,false',
        alt: 'Overview of a housing community'
      },
      { 
        name: 'Retail', 
        value: 26, 
        backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/woman-near-pigeons-CCx6Fz_CmOI.jpg?tr=w-600,h-400,f-auto,pr-true,false',
        alt: 'A fashionable woman near pigeons in a urban area',
      },
      { 
        name: 'Teknik', 
        value: 12, 
        backgroundImage: 'https://ik.imagekit.io/investoract/finansia/media/images/silver-macbook-paSLTZpHCdo_7dMbU09.jpg?tr=w-600,h-400,f-auto,pr-true,false',
        alt: 'A silver macbook'
      },
    ]
  }
  static getListByRegion(region) {
    return SectorAPI.sectors[region]
  }
  static getListByCountryId(countryId) {
    if (countryId === COUNTRY_SWEDEN_ID) {
      return SectorAPI.sectors['scandinavia']
    }
    return SectorAPI.sectors['global']

  }
}

class InstrumentEditorAPI {
  static async getList({offset = 0, limit = 20, search=''}) {
    const params = searchParamsFromObject({
      offset, limit, search,
    }).toString();
    let url = `${ROOT_URL}/api/v1/market/editor/instruments/?${params}`
    const res = await AuthenticationAPI.get(url);
    const data = await res.json();
    return data;
  }

  static async getItem({id}) {
    let url = `${ROOT_URL}/api/v1/market/editor/instruments/${id}/`
    const res = await AuthenticationAPI.get(url);
    const data = await res.json();
    return data;
  }

  static async updateItem({id, payload}) {
    let url = `${ROOT_URL}/api/v1/market/editor/instruments/${id}/`
    const res = await AuthenticationAPI.patch(url, payload, null, 'form');
    const data = await res.json();
    return data;
  }
}

class SectorEditorAPI {
  static async getList({search = '', offset = 0, limit = 20}) {
    const params = searchParamsFromObject({
      offset, limit, search
    }).toString();
    let url = `${ROOT_URL}/api/v1/market/editor/sectors/?${params}`
    const res = await AuthenticationAPI.get(url);
    const data = await res.json();
    return data;
  }
  
  static async getItem({id}) {
    let url = `${ROOT_URL}/api/v1/market/editor/sectors/${id}/`
    const res = await AuthenticationAPI.get(url);
    const data = await res.json();
    return data;
  }

  static async updateItem({id, payload}) {
    let url = `${ROOT_URL}/api/v1/market/editor/sectors/${id}/`
    const res = await AuthenticationAPI.patch(url, payload, null, 'form');
    const data = await res.json();
    return data;
  }
}

export { 
  TransactionAPI, 
  InstrumentAPI, 
  InstrumentEditorAPI,
  SectorAPI,
  SectorEditorAPI,
}